
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes as Routes1, useLocation } from 'react-router-dom'
import { PrivacyPolicy } from "./pages/privicyPolicy";
import App from "./App";
import AccountDeletion from './pages/accountDeletion';
import { Support } from './pages/support';
import { trackPageView } from './analytics/googleAnalytics';
import { CookieBanner } from './components/CookieBanner';

// Readable names in the GA4 "Pages and screens" report. Without these every
// route reports the same document title ("Parallel Poker") and you have to read
// paths to tell them apart.
const PAGE_TITLES: Record<string, string> = {
    '/': 'Home',
    '/privacypolicy': 'Privacy Policy',
    '/deleteaccount': 'Request Account Deletion',
    '/support': 'Support',
};

/**
 * Sends a GA4 page_view on first load and on every navigation.
 *
 * This is a single-page app: react-router changes the URL without a document
 * load, so GA4's automatic page_view would only ever fire once. gtag is
 * configured with send_page_view: false and this drives it instead — see
 * analytics/googleAnalytics.ts.
 *
 * Must live inside <Router> to be able to call useLocation().
 */
function AnalyticsPageViews() {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname + location.search;
        const title = PAGE_TITLES[location.pathname.toLowerCase()];
        trackPageView(path, title);
    }, [location.pathname, location.search]);

    return null;
}

export function RoutesMe() {
    return (
        <div>
            <Router>
                <AnalyticsPageViews />
                <Routes1>
                    <Route path="/" element={
                        <App />}>
                    </Route>
                    <Route path="/privacypolicy" element={
                        <PrivacyPolicy />}>
                    </Route>
                    <Route path="/deleteAccount" element={
                        <AccountDeletion />}>
                    </Route>
                    <Route path="/support" element={
                        <Support />}>
                    </Route>
                </Routes1>
                {/* Outside <Routes> so it persists across navigation, and last
                    so it paints over the page content. */}
                <CookieBanner />
            </Router>
        </div>
    );

}
